import { tabbable } from 'tabbable';

const focusFirst = (el, findTabbable = tabbable) => {
  if (!el) { return; }
  const result = findTabbable(el)[0];
  if (result) { result.focus(); }
};

export default focusFirst;
